<div class="example-box add-widget-item-modal" cdkDrag>
    <div class="modal-header add-widget-item-modal__header" cdkDragHandle>
        <div class="add-widget-item-modal__headline">
            <span class="add-widget-item-modal__eyebrow">{{ 'WIDGET_LABEL' | translate }}</span>
            <h4 class="modal-title add-widget-item-modal__title">{{ 'ADD_SAVED_SEARCH_TO_WIDGET' | translate:{ widgetName: widgetName } }}</h4>
        </div>
        <button type="button" class="add-widget-item-modal__close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
            <span class="add-widget-item-modal__close-glyph" aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body add-widget-item-modal__body">
        <div class="add-widget-item-modal__field row mb-0">
            <label class="col-sm-3 add-widget-item-modal__label">{{ 'SEARCHES' | translate }}</label>
            <div class="col-sm-9 add-widget-item-modal__control-wrap">
                <ng-select class="add-widget-item-modal__select" [placeholder]="'SELECT' | translate" [multiple]="true" (change)="selectionChange($event)" [items]="savedSearches" bindLabel="name"
                    bindValue="id">
                </ng-select>
            </div>
        </div>
    </div>
    <div class="modal-footer add-widget-item-modal__footer">
        <button type="button" class="red-outline-button add-widget-item-modal__button add-widget-item-modal__button--cancel" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
        <button type="submit" class="blue-button add-widget-item-modal__button" (click)="save()">{{ 'SAVE' | translate }}</button>
    </div>
</div>
